import { createContext, useContext, useMemo, ReactNode } from 'react';

import { ContentWorkingCopyManager } from '../common/ContentWorkingCopyManager';
import { MplServiceClientFactory } from '../api/MplServiceClientFactory';
import { AutoSavingService } from '../services/AutoSavingService';

const AutoSavingServiceContext = createContext<AutoSavingService | undefined>(undefined);

export function AutoSavingServiceProvider({ children }: { children: ReactNode }) {
  const service = useMemo(
    () => new AutoSavingService(new ContentWorkingCopyManager(MplServiceClientFactory.createV2())),
    [],
  );
  return (
    <AutoSavingServiceContext.Provider value={service}>
      {children}
    </AutoSavingServiceContext.Provider>
  );
}

export function useAutoSavingService(): AutoSavingService {
  const context = useContext(AutoSavingServiceContext);
  if (!context) {
    throw new Error('useAutoSavingService must be used within AutoSavingServiceProvider');
  }
  return context;
}
